import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { routes } from './app.routes';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { LIGHTBOX_CONFIG, LightboxConfig } from 'ng-gallery/lightbox';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideAnimations(),
    {
      provide: GALLERY_CONFIG,
      useValue: {
        autoHeight: true,
        imageSize: 'cover'
      } as GalleryConfig
    },
    {
      provide: LIGHTBOX_CONFIG,
      useValue: {
        // 'fullscreen' makes the lightbox fill the viewport on any screen size instead of a fixed 1100x800 box
        panelClass: ['g-overlay', 'fullscreen'],
      } as LightboxConfig
    },
    provideLuxonDateAdapter(environment.AppConfig.DateFormats),
    // Keep overlays (mat-select, datepicker, etc.) in normal stacking order so the fixed header can render above them on scroll
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
  ]
};
